<template>
    <div>
        <div v-for="(data, idx) in listBank" :key="`list-bank-${idx}`">
            <div class="separator-line m-d-12" v-if="idx !== 0"></div>
            <div class="m-d-12 d-flex-between-center">
                <div class="d-flex-between-center">
                    <img
                        :src="`https://res.cloudinary.com/sinadme/c_scale,h_100/${data.data_bank.logo}`"
                        class="m-r-16"
                        width="40"
                    />
                    <div class="f-14 f-regular data-bank">
                        <p class="m-d-0 f-c-midgrey">{{ data.data_bank.nama }}</p>
                        <p class="m-d-0 f-16">{{ data.no_rekening }}</p>
                        <p class="m-d-0 f-c-midgrey">{{ data.nama_pemilik }} {{ data.nama_pemilik }}</p>
                    </div>
                </div>
                <div><BtnSalin :copy-text="data.no_rekening" :id="`salin-rekening-${idx}`" :btn-label="'Salin'" /></div>
            </div>
        </div>
    </div>
</template>
<script>
import BtnSalin from "../components/BtnSalin.vue";

export default {
    name: "ListBankPembayaran",
    components: {
        BtnSalin,
    },
    props: {
        listBank: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>
<style scoped>
.data-bank {
    max-width: unset;
}

@media (min-width: 320px) {
    .data-bank {
        max-width: 164px;
    }
}

@media (min-width: 350px) {
    .data-bank {
        max-width: 195px;
    }
}

@media (min-width: 400px) {
    .data-bank {
        max-width: 240px;
    }
}
</style>
